import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { Layout } from "@/components/crm/Layout";
import BoardPage from "@/pages/BoardPage";
import LeadLogPage from "@/pages/LeadLogPage";
import TeamPage from "@/pages/TeamPage";
import DashboardPage from "@/pages/DashboardPage";
import ActivityPage from "@/pages/ActivityPage";
import ProjectionPage from "@/pages/ProjectionPage";
import LoginPage from "@/pages/LoginPage";
import AccountPage from "@/pages/AccountPage";
import UsersPage from "@/pages/UsersPage";

const SignedInApp = () => (
  <RequireAuth>
    <DataProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<BoardPage />} />
          <Route path="/leads" element={<LeadLogPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/activity" element={<ActivityPage />} />
          <Route path="/projection" element={<ProjectionPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/users" element={<UsersPage />} />
        </Routes>
      </Layout>
    </DataProvider>
  </RequireAuth>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<SignedInApp />} />
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
